// extracted by mini-css-extract-plugin
export var inPageNavHolder = "InPageNav-module--inPageNavHolder--3Ypw-";
export var progressBarHolder = "InPageNav-module--progressBarHolder--DGoL7";